<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="7" :xs="24">
          <!-- <el-date-picker
                            v-model="time"
                            :clearable="false"
                            :picker-options="pickerOptions"
                            end-placeholder="结束日期"
                            range-separator="至"
                            start-placeholder="开始日期"
                            type="daterange"
                            value-format="timestamp"/> -->
          <lp-date-picker
            ref="lpDatePicker"
            @finish="handleLpDatePickerChange"
          />
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-table v-loading="loadTable" :data="records" stripe>
      <el-table-column label="用户类型" prop="memberType">
        <template #default="scope">
          <template v-if="scope.row.memberType == '1'"> 微信用户 </template>
          <template v-else-if="scope.row.memberType == '7'">
            支付宝用户
          </template>
          <template v-else-if="scope.row.memberType == '3'">
            电卡用户
          </template>
        </template>
      </el-table-column>
      <el-table-column fixed label="用户手机号" prop="user.phone" />
      <el-table-column label="充电时长" prop="freeChargeNum" />
      <el-table-column label="创建时间" min-width="100">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime) }}
        </template>
      </el-table-column>
      <el-table-column label="最大功率" min-width="100">
        <template #default="scope"> {{ scope.row.maxPower }}W </template>
      </el-table-column>

      <el-table-column label="有效期">
        <template #default="scope"> {{ scope.row.timeLen }}天 </template>
      </el-table-column>
      <el-table-column label="金额" prop="money" />

      <el-table-column label="付款方式" prop="payType">
        <template #default="scope">
          <template v-if="scope.row.payType == '1'"> 微信支付 </template>
          <template v-else-if="scope.row.payType == '2'"> 余额支付 </template>
          <template v-else-if="scope.row.payType == '3'"> 代充 </template>
        </template>
      </el-table-column>

      <!--            <el-table-column label="操作" width="220">-->
      <!--                <el-button-->
      <!--                        type="danger" @click="refundOrder(scope.row.id)">退单-->
      <!--                </el-button>-->
      <!--            </el-table-column>-->
    </el-table>
    <page :current="current" :size="size" :total="total" />
  </div>
</template>

<script>
import MemberMonthlyLogController from "@/api/device/MemberMonthlyLogController";
import Page from "@/components/Page";
import createdMixin from "@/mixin/createMixin";
import pageMixin from "@/mixin/pageMixin";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";

export default {
  name: "UserManageDetailThree",
  components: { Page },
  mixins: [createdMixin, pageMixin, searchMixin, timeMixin],
  data() {
    return {
      time: "",
      records: [],
      params: {
        memberType: 1,
        memberId: this.$route.params.id,
        startTime: undefined,
        endTime: undefined,
        pageNum: undefined,
        size: undefined,
        sortName: "id",
        sortType: "DESC",
      },
    };
  },
  methods: {
    fetchData() {
      this.loadTable = true;
      this.params.pageNum = this.current;
      this.params.size = this.size;
      MemberMonthlyLogController.agentGetMonthlyRecord(this.params)
        .then((res) => {
          this.total = res.data.total;
          this.records = res.data.records;
        })
        .finally(() => {
          this.loadTable = false;
        });
    },
  },
};
</script>
